import SystemFieldProto from '../../proto/system-field-proto';

export default class ProjectStatusCommentsField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.PROJECT_STATUS_COMMENTS
    }

    getCsvValue(item) {
        return item
    }

    normalizeCSVValue(value) {
        return value
    }
}